import profileService from '@/services/profile-service';
import projectService from '@/services/project-service';

export async function loadUserAvatarBlob(userId?: number): Promise<Blob | undefined> {
    if (userId === undefined) {
        return undefined;
    }

    return profileService.getUserAvatar(userId);
}

export async function loadProjectImageBlob(projectId?: number): Promise<Blob | undefined> {
    if (projectId !== undefined) {
        return projectService.getProjectImage(projectId);
    }
}
